import { Box, CircularProgress, Link, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { MdAttachFile } from 'react-icons/md';
import {
  ArquivoRespostaMeta,
  FormularioRespostasII,
} from '../../../../interfaces/form-flow';
import { getAnswerForm } from '../../../../services/form-flow';
import { extrairArquivosDasRespostas } from './formatar-valor-resposta';

type DocumentosFormularioSectionProps = {
  identificador: string;
  cpf: string;
  hasDocumentosFluxo: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  attachText: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 400,
    textDecoration: 'none',
    color: '#0F6FB7',
  },
  textLink: {
    margin: '5px 0px 5px 14px',
    textDecoration: 'none',
    color: '#0F6FB7',
  },
  iconRequests: {
    height: 24,
    width: 24,
  },
  emptyText: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 400,
    color: '#0F6FB7',
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
}));

/**
 * Busca e lista apenas os arquivos enviados no formulário da solicitação.
 */
export default function DocumentosFormularioSection({
  identificador,
  cpf,
  hasDocumentosFluxo,
}: DocumentosFormularioSectionProps): JSX.Element | null {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(true);
  const [arquivos, setArquivos] = useState<ArquivoRespostaMeta[]>([]);

  useEffect(() => {
    let isCancelled = false;
    const fetchArquivos = async () => {
      if (!identificador || !cpf) {
        setLoading(false);
        setArquivos([]);
        return;
      }
      setLoading(true);
      try {
        const { data } = await getAnswerForm({
          identificador,
          cpf,
        });
        const payload = data as FormularioRespostasII;
        if (!isCancelled) {
          setArquivos(extrairArquivosDasRespostas(payload?.results || []));
        }
      } catch {
        if (!isCancelled) {
          setArquivos([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };
    fetchArquivos();
    return () => {
      isCancelled = true;
    };
  }, [identificador, cpf]);

  if (loading) {
    return (
      <Box className={classes.loadingBox}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (arquivos.length === 0) {
    if (hasDocumentosFluxo) {
      return null;
    }
    return (
      <Typography className={classes.emptyText}>Sem documentos</Typography>
    );
  }

  return (
    <>
      {arquivos.map(arquivo => (
        <Typography className={classes.attachText} key={String(arquivo.id)}>
          <MdAttachFile className={classes.iconRequests} />
          <Link
            href={arquivo.url}
            target='_blank'
            rel='noopener noreferrer'
            className={classes.textLink}
          >
            {arquivo.nome}
          </Link>
        </Typography>
      ))}
    </>
  );
}
